exports.loadingShow = () => {
    document.getElementById("global-loading").style.display = "block"
}
exports.loadingHide = () => {
    document.getElementById("global-loading").style.display = "none"
}